import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Homepage from "../HomePage";
import Links from "../Links";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/kit-neuroalfabetizacao" element={<Homepage />} />
          <Route path="/links" element={<Links />} />
          <Route path="/" element={<Navigate to="/links" />} />
          <Route path="*" element={<Navigate to="/links" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
